import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonLink,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text2,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useEffect } from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useLocalObservable } from "mobx-react-lite";
import { PostBalanceInquiryRequestFetchStore } from "../../../stores";
import { useNavigateCustom, useOpenFGTSApp } from "../../../hooks";
import { useAnalytics } from "../../../hooks/useAnalytics";

export const InexistentAnniversaryMembership: React.FC = () => {
	const errorInfo = strings.components.connectionFeedback.errors;

	const { isDesktopOrBigger } = useScreenSize();
	const { authenticationStore } = useGlobalStore();
	const { addAnalyticEvent, updatePageView } = useAnalytics();
	const navigation = useNavigateCustom();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(
			authenticationStore,
			() => navigation("/connect-fgts-balance"),
		),
	);

	const handleAddAnalyticEvent = (description: string ): void => {
		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description,
			step: "fgts:saque-aniversario-desabilitado",
			value: "",
		}, {applySanitize: true});
	};

	const handleOnPressButton = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.inexistentAnniversaryMembership.buttons.primaryButton);
		store.fetchShelf.fetch();
	};

	const handleOnPressLink = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.anniversaryMembershipEgress.buttons.linkButton);
		useOpenFGTSApp();
	};

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "saque-aniversario-desabilitado",
			step: "fgts:saque-aniversario-desabilitado",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Saque Aniversário Desabilitado",
			pagePath: "/fgts/saque-aniversario-desabilitado",
		});
	},[]);


	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.inexistentAnniversaryMembership.title}
						description={errorInfo.inexistentAnniversaryMembership.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={handleOnPressButton}
								showSpinner={store.fetchShelf.loader.isLoading}
								disabled={store.fetchShelf.loader.isLoading}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.inexistentAnniversaryMembership.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
							{!isDesktopOrBigger && (
								<ButtonLink
									onPress={handleOnPressLink}
									disabled={store.fetchShelf.loader.isLoading}
								>
									<Text2 medium color={skinVars.colors.textLink}>
										{errorInfo.anniversaryMembershipEgress.buttons.linkButton}
									</Text2>
								</ButtonLink>
							)}
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default InexistentAnniversaryMembership;
